import { useOurNetworkContent } from '../../../context/ContentContext';

// Partner Logos
import revoltLogo from '../../../assets/images/Revolt.svg';
import revoltSportsLogo from '../../../assets/images/Revolt_sports.svg';
import threeBlackDotLogo from '../../../assets/images/3blackDot.svg';
import rcnLogo from '../../../assets/images/RCN.svg';
import rapupLogo from '../../../assets/images/Rapup.svg';
import './OurNetwork.css';

const logoMap = {
    'Revolt.svg': revoltLogo,
    'Revolt_sports.svg': revoltSportsLogo,
    '3blackDot.svg': threeBlackDotLogo,
    'RCN.svg': rcnLogo,
    'Rapup.svg': rapupLogo
};

export default function OurNetwork() {
    const network = useOurNetworkContent();

    if (!network) return null;

    // We can still use the same JSON structure for `network` but maybe the user wants it to look like the design.
    // Assuming the title and subtitle in variants.json already match the new design.
    const { title, partners } = network;

    return (
        <section className="our-network" id='440advantage'>
            <div className="our-network__inner max-width">
                <header className="our-network__header">
                    {network.preTitle && <p className="our-network__pre-title">{network.preTitle}</p>}
                    <h2 className="our-network__title">
                        {title.main}<br />
                        <span className="our-network__title-highlight">{title.highlight}</span>
                        {title.afterHighlight ? ` ${title.afterHighlight}` : ''}
                    </h2>
                    <div className="our-network__subtitle">{network.subtitle}</div>
                </header>

                <div className="our-network__content">
                    <div className="our-network__left">
                        <iframe
                            src="/ecosystem-animation.html?v=3"
                            title="440 Ecosystem Animation"
                            className="our-network__animation-iframe"
                            frameBorder="0"
                            scrolling="no"
                        ></iframe>
                    </div>
                    <div className="our-network__right">
                        <div className="our-network__list">
                            {partners.map((partner, index) => (
                                <div
                                    key={index}
                                    className="our-network__partner-card"
                                >
                                    <div className="our-network__partner-logo-container">
                                        <div className="our-network__partner-logo-circle">
                                            <img src={logoMap[partner.logo]} alt={partner.name} className="our-network__partner-logo-img" />
                                        </div>
                                    </div>
                                    <div className="our-network__partner-info">
                                        <div className="our-network__partner-name">{partner.name}</div>
                                        <p className="our-network__partner-description">{partner.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
}
